
jQuery('#clear-form').click(function () {
  var onlyUrl = window.location.href.replace(window.location.search,'');

  // jQuery("#input-value").val("");
  window.location = onlyUrl;
});

jQuery('#clear-form-mobile').click(function () {
  var onlyUrl = window.location.href.replace(window.location.search,'');

  // jQuery("#input-value").val("");
  window.location = onlyUrl;
});
